import styled from 'styled-components';

interface CompareToggleBarProps {
    show: boolean;
}

export const CompareClearBtn = styled.button`
    background-color: transparent;
    border: 0 none;
    margin-left: 8px;
    color: #999;
    font-size: 14px;
    cursor: pointer;
`

export const CompareToggleBar = styled.div<CompareToggleBarProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    width: 100%;
    bottom: ${({ show }) => show ? '0' : '-200px'};
    right: 0;
    opacity: ${({ show }) => show ? 1 : 0};
    background-color: #fff;
    padding: 16px 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, .3);
    border-top: 1px solid #ddd;
    transition: all .3s;
    z-index: 1;
`

export const CompareTableWrapper = styled.div`
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    table td {
        border-bottom: 1px solid #eee;
        padding: 12px 8px;
        text-align: center;
        font-size: 14px;
    }

    table tr:last-child td {
        border-bottom: 0 none;
    }

    table td.th {
        text-align: left;
        background-color: #fafafa;
        width: 160px;
        font-size: 13px;
        line-height: 1.2;
    }

    td i {
        color: #999;
        font-size: 14px;
        font-style: normal;
    }

    @media (max-width: 768px) {
        table td {
            padding: 8px 6px;
        }

        button {
            font-size: 12px;
            padding: 8px 6px;
            line-height: 1.2;
        }
    }
`

export const StyledPlanList = styled.div`
    display: flex;
    flex-wrap: wrap;
`
export const StyledPlanTitle = styled.p`
    color: #2372B9;
    text-align: left;
    line-height: 1 ;
    font-size:1.3rem;
    margin-bottom:0;
    flex: 0 0 96% !important;
`

export const StyledPlanRow = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #fff;
    color: #000000de;
    transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    box-shadow: rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px;
    overflow: hidden;
    border-radius: 24px;
    border: 2px solid #E5E5E5;
    flex: 0 0 46%;
    margin: 2%;
    padding: 20px 24px;

    & > div {
        flex: 1;
    }

    @media (max-width: 768px) {
        flex: 0 0 96% !important;
    }
`

export const StyledPlanReview = styled.div`
    background-color: #fff;
    color: #000000;
    box-shadow:'5px 5px #2372B9';
    padding: 20px 24px;
    border: 1px solid #D9D9D9;
    border-radius: 30px
    & > div {
        flex: 1;
    }

    @media (max-width: 768px) {
        flex: 0 0 96%;
    }
`

